import React, { useState, useEffect } from "react";
import Spinner from "../../reusables/spinner";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import InputField from "../../reusables/input";
import DeleteModal from "../../modals/deleteModal";
import EditCustomerModal from "../../modals/editCustomerModal";
import { connect } from "react-redux";
import {
  fetch_unapproved_customers,
  search_unapproved_customers,
} from "../../../redux/actions/adminActions";
import { periods, user_status } from "../../../utils/options";
import ApproveModal from "../../modals/approveModal";
import DeclineModal from "../../modals/declineModal";
import Pagination from "../../reusables/pagination";

function AwaitingApproval({
  unapprovedCustomers,
  getUnapprovedCustomers,
  accessToken,
  searchUnapprovedCustomers,
}) {
  let token = accessToken;
  let filters = ["first_name", "last_name", "phone", "email"];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getUnapprovedCustomers({ token, success });
  }, [getUnapprovedCustomers, accessToken]);

  const [optionsActive, setOptions] = useState(null);

  const [deleteModal, setDelete] = useState({ modal: false, users: [] });

  const [edit, setEdit] = useState({ modal: false, user: null });

  const [filter, setFilters] = useState(filters[0]);

  const [search, setSearch] = useState("");

  const [suggestions, setSuggest] = useState([]);

  const [approve, setApprove] = useState({ modal: false, users: [] });

  const [selectedCustomers, setSelected] = useState([]);

  const handleOption = (id) => {
    if (optionsActive !== null) {
      setOptions(null);
    } else {
      setOptions(id);
    }
  };

  const handleSelect = (e) => {
    let updatedList = [...selectedCustomers];
    if (e.target.checked) {
      updatedList = [...selectedCustomers, Number(e.target.value)];
    } else {
      updatedList.splice(selectedCustomers.indexOf(e.target.value), 1);
    }
    setSelected(updatedList);
  };

  const searchHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    searchUnapprovedCustomers(accessToken, filter, search, success);
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    getUnapprovedCustomers({ token, success, filter });
  };

  const success = () => {
    setLoading(false);
  };

  const handleSuggestions = (e) => {
    let results = [];

    setSuggest(results);
    setSearch(e.target.value);

    unapprovedCustomers?.data.map((item) => {
      switch (filter) {
        case "first_name":
          let fname_matches = item?.first_name?.match(e.target.value);
          if (fname_matches && results.length < 3) {
            results.push(fname_matches?.input);
          }

          break;

        case "last_name":
          let lname_matches = item?.last_name?.match(e.target.value);
          if (lname_matches && results.length < 3) {
            results.push(lname_matches?.input);
          }
          break;

        case "phone":
          let phone_matches = item?.phone?.match(e.target.value);
          if (phone_matches && results.length < 3) {
            results.push(phone_matches?.input);
          }
          break;

        case "email":
          let email_matches = item?.email?.match(e.target.value);
          if (email_matches && results.length < 3) {
            results.push(email_matches?.input);
          }
          break;

        default:
          break;
      }
    });
  };

  const resetSearch = () => {
    setSearch("");
    getUnapprovedCustomers({ token });
  };

  const onPageChange = (page) => {
    setLoading(true);
    getUnapprovedCustomers({ token, success, page });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder isRelative ">
            <div className="alignOnly">
              <Dropdown value={filter} className="mx-1">
                {filters.map((item) => (
                  <div
                    className="isClickable hoverGreen"
                    onClick={() => setFilters(item)}
                  >
                    <p className="sectionText px-3 py-2 mb-0">{item}</p>
                  </div>
                ))}
              </Dropdown>
              <InputField
                inputClass="mx-1"
                iconClick={searchHandler}
                value={search}
                onChange={handleSuggestions}
                placeholder={`Search by ${filter}`}
                icon
                iconClass="ri-search-line"
              />

              {search !== "" && (
                <span
                  className="isRed sectionText--small mx-2 isClickable"
                  onClick={resetSearch}
                >
                  Clear Filter
                </span>
              )}
            </div>

            {suggestions?.length > 0 && (
              <div className="suggestions_holder isRelative">
                <div className="suggestions">
                  {suggestions?.map((item) => (
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => {
                        setSearch(item);
                        setSuggest([]);
                      }}
                    >
                      <p className="sectionText px-3 py-2 mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="alignOnly pt-2">
            <button
              className={`btn__filled ${
                !selectedCustomers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedCustomers.length > 0}
              onClick={() => {
                setApprove({ modal: true, users: selectedCustomers });
              }}
            >
              Verify
            </button>

            <button
              className={`btn__red ${
                !selectedCustomers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedCustomers.length > 0}
              onClick={() => {
                setDelete({
                  modal: true,
                  users: [...deleteModal.users, ...selectedCustomers],
                });
              }}
            >
              Delete
            </button>

            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        <div className="fullHeight py-5">
          {!loading ? (
            unapprovedCustomers?.data.length > 0 ? (
              <table className="table">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">ID Type</th>
                    <th className="vAlign">ID Number</th>

                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {unapprovedCustomers?.data.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          value={item.id}
                          onChange={handleSelect}
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item.display_pic}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item.first_name + " " + item.last_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">{item.phone}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">{item.email}</p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">{item.address}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item.date}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">Drivers Licence</p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">57684947648</p>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOption(item.id)}
                        ></i>

                        {optionsActive === item.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom pb-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <p
                                className="hasBorder--bottom py-2 mb-0"
                                onClick={() =>
                                  setApprove({
                                    ...approve,
                                    modal: true,
                                    users: [...approve.users, item.id],
                                  })
                                }
                              >
                                Verify
                              </p>
                              <p
                                className="isRed py-2 mb-0"
                                onClick={() =>
                                  setDelete({
                                    ...deleteModal,
                                    modal: true,
                                    users: [...deleteModal.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </p>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid center pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No customer found
                </h2>
              </div>
            )
          ) : (
            <Spinner big />
          )}
          <div className="d-flex justify-content-end">
            <Pagination
              onChange={onPageChange}
              page={unapprovedCustomers?.current_page}
              total={unapprovedCustomers?.total}
              per_page={unapprovedCustomers?.per_page}
            />
          </div>
        </div>
      </div>

      <EditCustomerModal
        unapproved
        user={edit.user}
        show={edit.modal}
        handleClose={() =>
          setEdit({
            ...edit,
            modal: false,
          })
        }
      />

      <DeleteModal
        unapproved
        show={deleteModal.modal}
        users={deleteModal.users}
        handleClose={() =>
          setDelete({
            ...deleteModal,
            modal: false,
          })
        }
      />
      <ApproveModal
        customer
        show={approve.modal}
        users={approve.users}
        handleClose={() =>
          setApprove({
            ...approve,
            modal: false,
          })
        }
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  unapprovedCustomers: state.admin.customers.unapproved,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getUnapprovedCustomers: (token, success) =>
    dispatch(fetch_unapproved_customers(token, success)),
  searchUnapprovedCustomers: (token, type, value, success) =>
    dispatch(search_unapproved_customers(token, type, value, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwaitingApproval);
